import React, { useContext, useState } from 'react'
import { ReactComponent as ActiveControl } from 'assets/img/svg/ActiveControl.svg';
import { ReactComponent as InactiveControl } from 'assets/img/svg/InactiveControl.svg';
import StatusChangeDialog from './StatusChangeDialog';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { RolePermissions, PermissionContext } from 'appContext';
import { pages } from 'views/pages/manage/common/constant';
import { capitalize } from '../../../../common/utils/methods/commonMethods/utilityMethod';

const StatusCellComponent = ({ params, toggleStatusHandler = () => { }, rowForm, rowFormHandler = () => { } }) => {

  const userPermissions = RolePermissions(useContext(PermissionContext), pages['sapProfitCostCentreMapping']['id']);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    params.api.getRowMode(params?.id) === 'view' ? (
      <div>
        <span>
          {params.value === "ACTIVE" ?
            <ActiveControl onClick={checkPermission(userPermissions, 'U') ? () => setIsDialogOpen(true) : () => { }} /> :
            <InactiveControl onClick={checkPermission(userPermissions, 'U') ? () => setIsDialogOpen(true) : () => { }} />
          }
          <span
            style={{
              fontSize: "14px", marginLeft: "4px",
              color: params.value === "ACTIVE" ? '#0F0F0F' : '#757575'
            }}
          >
            {capitalize(params?.value)}
          </span>
        </span>
        <StatusChangeDialog
          open={isDialogOpen}
          setOpen={setIsDialogOpen}
          rowData={params?.row}
          onAgree={() => toggleStatusHandler(params?.row)}
        />
      </div>
    ) : (
      <div>
        <span>
          {rowForm.costCenterStatus === "ACTIVE" ?
            <ActiveControl onClick={() => setIsDialogOpen(true)} /> :
            <InactiveControl onClick={() => setIsDialogOpen(true)} />
          }
          <span
            style={{
              fontSize: "14px", marginLeft: "4px",
              color: rowForm.costCenterStatus === "ACTIVE" ? '#0F0F0F' : '#757575'
            }}
          >
            {capitalize(rowForm.costCenterStatus)}
          </span>
        </span>
        <StatusChangeDialog
          open={isDialogOpen}
          setOpen={setIsDialogOpen}
          rowData={rowForm}
          onAgree={() => rowForm?.costCenterStatus === 'ACTIVE' ? rowFormHandler('INACTIVE', 'costCenterStatus') : rowFormHandler('ACTIVE', 'costCenterStatus') }
        />
      </div>
    )
  )
}

export default StatusCellComponent